import React from 'react';
import { AppRegistry } from 'react-native';
import { polyfillFetch } from 'fitbeat.react-native-components';
import App from './App';

polyfillFetch(parseInt(DEFAULT_FETCH_TIMEOUT), fetch);
AppRegistry.registerComponent('Fitbeat', () => App);

AppRegistry.runApplication('Fitbeat', {
    initialProps: {},
    rootTag: document.getElementById('root')
});